/**
 * Parallax — scroll parallax for .mediastrip and .imgband background images.
 * Ported from the Leapfrog design build (parallax.js).
 * Translates the inner image a fraction of scroll. No-op under reduced-motion.
 */

export function initParallax() {
	if ( window.matchMedia && window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) return;

	const items = [];
	document.querySelectorAll( '.mediastrip, .imgband' ).forEach( ( el ) => {
		const img = el.querySelector( 'img' );
		if ( ! img ) return;
		el.classList.add( 'parallax-on' );
		items.push( { el, img, range: el.classList.contains( 'imgband' ) ? 95 : 80 } );
	} );
	if ( ! items.length ) return;

	let ticking = false;

	function update() {
		const vh = window.innerHeight || document.documentElement.clientHeight;
		for ( const it of items ) {
			const r = it.el.getBoundingClientRect();
			if ( r.bottom < -50 || r.top > vh + 50 ) continue;
			const center = r.top + r.height / 2;
			let ratio = ( center - vh / 2 ) / vh; // ~ -0.7 .. 0.7
			if ( ratio > 0.8 ) ratio = 0.8;
			else if ( ratio < -0.8 ) ratio = -0.8;
			const offset = ( -ratio * it.range ).toFixed( 1 );
			it.img.style.transform = `translate3d(0,${ offset }px,0)`;
		}
		ticking = false;
	}

	function onScroll() {
		if ( ! ticking ) {
			ticking = true;
			requestAnimationFrame( update );
		}
	}

	window.addEventListener( 'scroll', onScroll, { passive: true } );
	window.addEventListener( 'resize', onScroll, { passive: true } );
	update();
}
